/**
 * Safely extracts a string from localized database fields.
 * Industry standard for handling multi-lang data in single-lang UIs.
 */
export const safeString = (field, fallback = "") => {
  if (!field) return fallback;

  // 1. If it's already a string (old data), return it
  if (typeof field === "string") return field;

  // 2. If it's a localized object, pick English
  if (typeof field === "object") {
    return field.en || field.ar || Object.values(field)[0] || fallback;
  }

  return fallback;
};